import { injectIntl } from "react-intl";
import React from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const formatYAxis = (value) => {
  if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `$${(value / 1_000).toFixed(0)}K`;
  return `$${value}`;
};

const RevenueCostTrends = ({ data = [] }) => {
  return (
    <div className="SmsAnalyticsChartCard SmsAnalyticsChartCardWide">
      <div className="SmsAnalyticsChartHeader">
        <div className="SmsAnalyticsChartTitle">Revenue &amp; Cost Trends</div>
        <div className="SmsAnalyticsChartLegend">
          <div className="SmsAnalyticsLegendItem">
            <span className="SmsAnalyticsLegendDot SmsAnalyticsLegendDotPurple" />
            Revenue
          </div>
          <div className="SmsAnalyticsLegendItem">
            <span className="SmsAnalyticsLegendDot SmsAnalyticsLegendDotRed" />
            Cost
          </div>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={280}>
        <AreaChart
          data={data}
          margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="revenueGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#7E50EA" stopOpacity={0.25} />
              <stop offset="95%" stopColor="#7E50EA" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#F0F1F5" vertical={false} />
          <XAxis
            dataKey="month"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#8185A8", fontSize: 12, fontFamily: "Inter" }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tickFormatter={formatYAxis}
            tick={{ fill: "#8185A8", fontSize: 12, fontFamily: "Inter" }}
            width={60}
          />
          <Tooltip
            formatter={(value) => [`$${Number(value).toLocaleString()}`, ""]}
            contentStyle={{
              borderRadius: 8,
              border: "1px solid #E5E7F0",
              fontSize: 12,
              fontFamily: "Inter",
            }}
          />
          <Legend content={() => null} />
          <Area
            type="monotone"
            dataKey="revenue"
            stroke="#7E50EA"
            strokeWidth={2}
            fill="url(#revenueGradient)"
            name="Revenue"
          />
          <Area
            type="monotone"
            dataKey="cost"
            stroke="#EF4444"
            strokeWidth={2}
            fill="none"
            name="Cost"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default injectIntl(RevenueCostTrends);
